// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"ee11b9fdd75002d1c04c","293":"0aefa8dd8adefb8b2a3b","518":"36d1734cce145f9712a4","779":"1b7d3651c819831687fe"}[chunkId] + ".js";
};